import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
function Clientlist() {
  let navigate = useNavigate();

  const tokens = Cookies.get("a_token");
  if (!tokens) {
    navigate("/");
  }
  const [clientdata, setClientdata] = useState([]);

  const getinfo = async (e) => {
    const res = await fetch("https://api.homedotapp.com/clientlist", {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    const data = await res.json();
    if (res.status === 404 || !data) {
      alert("error");
    } else {
      setClientdata(data);
    }
  };
  useEffect(() => {
    getinfo();
  }, []);

  const deleteclient = async (id) => {
    const response = await fetch(
      `https://api.homedotapp.com/deleteclient/${id}`,
      {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
      }
    );

    const deletedata = await response.json();

    if (response.status === 404 || !deletedata) {
    } else {
      alert("data removed");
      getinfo();
    }
  };

  return (
    <div className="container-scroller">
      <Navbar />

      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        {/* partial */}
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Client List</h4>
                    <div className="table-responsive pt-3">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Sl.No</th>
                            <th>Name</th>
                            <th>Designation</th>
                            <th>Description</th>
                            <th>Image</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {clientdata.map((element, i) => {
                            return (
                              <>
                                <tr>
                                  <th scope="row">{i + 1}</th>
                                  <td>{element.name}</td>
                                  <td>{element.designation}</td>
                                  <td>{element.description}</td>
                                  <td>
                                    <img
                                      src={element.clientImage}
                                      width="50"
                                      alt=""
                                    />
                                  </td>
                                  <td className="d-flex justify-content-between">
                                    <button
                                      onClick={() => deleteclient(element._id)}
                                    >
                                      <i className="fa-solid fa-trash" />
                                    </button>
                                    {/* <button><i className="fa-solid fa-pen" /></button> */}
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Clientlist;
